export const DEFAULT_CREATE_ORDER = ['/create', '/create-poll', '/create?type=video', '/create-quiz', '/create?type=newspaper', '/drafts'];
export const createMenuKey = account => `amposter:create-menu:v2:${account || 'guest'}`;
const legacyKey = account => `amposter:create-menu:v1:${account || 'guest'}`;
const validPaths = value => Array.isArray(value) ? [...new Set(value.filter(path => DEFAULT_CREATE_ORDER.includes(path)))] : [];
export function normalizeCreateMenu(value) {
  const order = validPaths(value?.order);
  return { order: [...order, ...DEFAULT_CREATE_ORDER.filter(path => !order.includes(path))], hidden: validPaths(value?.hidden) };
}
export function readCreateMenuSettings(account) {
  try {
    const value = localStorage.getItem(createMenuKey(account));
    if (value !== null) return normalizeCreateMenu(JSON.parse(value));
    return normalizeCreateMenu({ hidden: JSON.parse(localStorage.getItem(legacyKey(account)) || '[]') });
  } catch { return normalizeCreateMenu({}); }
}
export function saveCreateMenuSettings(account, value) {
  const next = normalizeCreateMenu(value);
  localStorage.setItem(createMenuKey(account), JSON.stringify(next));
  // Only remove the previous key after the new preferences were saved.
  try { localStorage.removeItem(legacyKey(account)); } catch { /* New preferences are already safely saved. */ }
  return next;
}
